import { useContext, useState } from "react";
import { Asset } from "../data/Asset";
import { HttpMethods } from "../enums/HttpMethods";
import { NotificationTypes } from "../enums/NotificationTypes";
import { ResidentDto } from "../dtos/ResidentDto";
import VspPortalContext from "../store/VspPortalContext";
import { VspPortalActions } from "../store/VspPortalActions";
import { useVspPortalHttp } from "./useVspPortalHttp";



type SearchDto = {
    
    birthDate: string | null
    cardHolderId: number,
    cardNumbers: string[],
    cardTypeCode: string | null,
    email: string,
    employeeNumber: string,
    firstName: string,
    mobileNumber: string,
    searchMatchedComments: string | null
    surname: string,

};

export const useSearchResidentHttp = ( ): {
        isLoading : boolean
        , searchByCardNumber( domain: Asset, cardNumber: string ) : Promise<ResidentDto[]>
        , searchByEmployeeId( domain: Asset, employeeId: string ) : Promise<ResidentDto[]>
        , searchByName( domain: Asset, firstName: string, hasValidCardCheck: boolean, surname: string ) : Promise< ResidentDto[] >
 } => {

    const [ isLoading, setIsLoading ] = useState<boolean>( false );

    const { dispatch } = useContext( VspPortalContext );
    const { fetchData, getHttpOptions } = useVspPortalHttp( );


    const searchByCardNumber = async ( domain: Asset, cardNumber: string ): Promise<ResidentDto[]> => {
        
        const residentDtos: ResidentDto[] = [];

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );
        const query = `${process.env.REACT_APP_API_URL}/resident/byCardNumber?cardTypeCode=${domain}_CT1&cardNumber=${cardNumber}`;
        
        setIsLoading( true );
        const response = await fetchData( options, query );
        setIsLoading( false );

        if ( response.statusCode !== 200 ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error searching cardholder by card number' });

            return residentDtos;

        }

        try {

            const searchDto: SearchDto = await response.response?.json( );

            if( !searchDto ) {
                
                return [];

            }

            residentDtos.push({

                asset: domain,
                cardNumbers: [ cardNumber ],
                employeeId: searchDto.employeeNumber,
                firstName: searchDto.firstName,
                surname: searchDto.surname

            });

        } catch {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error searching cardholder by card number' });

        }

        return residentDtos;

    };


    const searchByEmployeeId = async ( domain: Asset, employeeId: string ): Promise<ResidentDto[]> => {

        setIsLoading( true );
        const residentDtos: ResidentDto[] = [];
        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );
        const query = `${process.env.REACT_APP_API_URL}/resident/byEmployeeId?employeeId=${employeeId}&assetCode=${domain}`;

        setIsLoading( true );
        const response = await fetchData( options, query );
        setIsLoading( false );

        if ( response.statusCode !== 200 ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error searching cardholder by employee id' });

            return residentDtos;

        }


        try {

            const searchDto: SearchDto = await response.response?.json( );

            if( !searchDto ) {
                
                return [ ];

            }

            residentDtos.push({

                asset: domain,
                cardNumbers: searchDto.cardNumbers,
                employeeId,
                firstName: searchDto.firstName,
                surname: searchDto.surname

            });

        } catch {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error searching cardholder by employee id' });

        }
        

        return residentDtos;

    };

    
    const searchByName = async ( domain: Asset, firstName: string, hasValidCardCheck: boolean, surname: string ): Promise< ResidentDto[ ] > => {
        
        const residentDtos: ResidentDto[] = [];
        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );
        const query = `${process.env.REACT_APP_API_URL}/residents/byName?assetCode=${domain}&hasValidCardCheck=${hasValidCardCheck}&firstName=${firstName}&surname=${surname}`;

        setIsLoading( true );
        const response = await fetchData( options, query );
        setIsLoading( false );

        if ( response.statusCode !== 200 ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error searching cardholder by name' });
            return residentDtos;

        }

        try {

            const searchDtos: SearchDto[] = await response.response?.json( );

            if( !searchDtos ) {
                
                return [];

            }

            for( const searchDto of searchDtos ) {

                residentDtos.push({

                    asset: domain,
                    cardNumbers: searchDto.cardNumbers,
                    employeeId: searchDto.employeeNumber,
                    firstName: searchDto.firstName,
                    surname: searchDto.surname

                });

            }

        } catch {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error searching cardholder by name' });

        }

        return residentDtos;

    };

    return { 
        isLoading
        , searchByCardNumber
        , searchByEmployeeId
        , searchByName 
    };

};